export { ActivateHomeComponent } from './activate-home.component';
export { ActivateHomeFormComponent } from './form/activate-home-form.component';
